import { HiOutlineBriefcase } from "react-icons/hi";

export default function CaseIcon({size}) {
    return <HiOutlineBriefcase size={size} />;
}